import React, { Component } from 'react';
import styled from 'styled-components';

import { Container, Row, Col, Paragraph, Button } from '../';

import { VideoModal } from './VideoModal';

const HeroContainer = Container.extend`
  position: relative;
  background-position: center;
  height: 500px;
  background-image: url('https://assets.homeimprovementpages.com.au/images/alexa/banner-1600.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  p {
    font-family: 'roboto';
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 60rem) {
    background-image: url('https://assets.homeimprovementpages.com.au/images/alexa/banner-mobile-960-1.jpg');
  }

  @media (max-width: 30rem) {
    padding-bottom: 50px;
  }

  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding-bottom: 90px;
`;

const Video = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
  overflow: hidden;
  background-size: cover;
  z-index: 1;

  video {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 60rem) {
    display: none;
  }
`;

const ButtonPlay = Button.extend`
  font-size: 15px;
  padding: 13px 0;

  background: rgba(255, 0, 0, 0.05);

  &,
  &:hover {
    color: #fff;
    border-color: #fff;
  }

  img {
    position: relative;
    top: 1px;
    margin-right: 10px;
  }
`;

// eslint-disable-next-line react/display-name
export class Hero extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false
    };
  }

  playVideo = () => {
    this.setState({ isOpen: true });
  };

  render() {
    const { isOpen } = this.state;

    return (
      <HeroContainer fluid>
        <Row style={{ zIndex: 2, position: 'relative' }}>
          <Col xs={12}>
            <Container>
              <Row>
                <Col
                  xs={12}
                  pl={{ xs: '10px', sm: '20px', lg: '88px' }}
                  pr={{ xs: '10px', sm: '20px', lg: '88px' }}
                >
                  <Paragraph style={{ lineHeight: 1.2, fontSize: '38px', fontWeight: 300 }}>
                    &quot;Alexa, launch hipages and find me a plumber&quot;
                  </Paragraph>
                  <Paragraph style={{ lineHeight: 1.6, fontSize: '15px', maxWidth: '560px' }}>
                    Introducing the hipages - Find a tradie skill for any Amazon Alexa-enabled
                    devices. Let hipages and Alexa take all the stress out of finding a qualified
                    tradie.
                  </Paragraph>
                  <div>
                    <Row mt={{ xs: 1, sm: 1.5 }}>
                      <Col xs={12} sm={6} md={3} lg={2.4}>
                        <Button
                          style={{
                            fontSize: '15px',
                            textDecoration: 'none',
                            color: '#FFF',
                            lineHeight: 1.2
                          }}
                          tag="a"
                          href="#get-started"
                          pt={'14px'}
                          pb={'14px'}
                          pl={0}
                          pr={0}
                          primary
                          block
                        >
                          Get Started
                        </Button>
                      </Col>
                      <Col xs={12} sm={6} md={3} lg={2.4}>
                        <ButtonPlay ghost block onClick={this.playVideo}>
                          <img src="https://assets.homeimprovementpages.com.au/images/alexa/button-arrow.png" />Watch
                          video
                        </ButtonPlay>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Video>
          <video
            autoPlay
            loop
            poster="http://assets.homeimprovementpages.com.au/images/alexa/banner-1600.jpg"
          >
            <source
              src="https://assets.homeimprovementpages.com.au/videos/alexa-banner-1600x.mp4"
              type="video/mp4"
            />
          </video>
        </Video>
        <VideoModal isOpen={isOpen} />
      </HeroContainer>
    );
  }
}
